module.exports = __webpack_public_path__ + "static/media/me-min.2da0448a.jpg";